// Manual monaco-editor worker wiring — replaces monaco-editor-webpack-plugin, which is
// incompatible with monaco-editor's newer package.json "exports" map (its extensionless
// require.resolve('monaco-editor/esm/...') calls no longer resolve). webpack's own
// resolver for `new Worker(new URL(...))` handles these same extensionless specifiers
// fine, so this needs no plugin — must be imported before any monaco-editor usage.
self.MonacoEnvironment = {
    getWorker(_moduleId: string, label: string) {
        switch (label) {
            case "json":
                return new Worker(new URL("monaco-editor/esm/vs/language/json/json.worker", import.meta.url));
            case "css":
            case "scss":
            case "less":
                return new Worker(new URL("monaco-editor/esm/vs/language/css/css.worker", import.meta.url));
            case "html":
            case "handlebars":
            case "razor":
                return new Worker(new URL("monaco-editor/esm/vs/language/html/html.worker", import.meta.url));
            case "typescript":
            case "javascript":
                return new Worker(new URL("monaco-editor/esm/vs/language/typescript/ts.worker", import.meta.url));
            default:
                return new Worker(new URL("monaco-editor/esm/vs/editor/editor.worker", import.meta.url));
        }
    },
};
